import {getReadingTime} from './getReadingTime';
import blogpost_data from '@/data/blog-post.data';


const LOCALE_MAP = {
  "pl": "pl",
  "en-GB": "uk",
  "uk": "ua",
  "de": "de",
  "cs": "cz",
  "ro": "ro",
  "hu": "hu",
  "sk": "sk",
  "bg": "bg",
  "fr": "fr",
  "it": "it",
  "es": "es",
  "nl": "nl",
  "sv": "se",
  "pt": "pt",
  "da": "dk",
  "fi": "fi"  
}

export const parsePosts = ({postsModel, post, category = null}) => postsModel?.map(({node}) => {
  const {
    seo, shortHeading, heading, category: nodeCategory, createdAtShortDate, dateFormat, createdAtFullDate,
    locale: node_locale, slug, shortContent, thumbnailImage, content
  } = node;


  const locale = LOCALE_MAP[node_locale];
  
  let categoryLabel = nodeCategory?.shortHeading || nodeCategory?.heading;
  const categoryHref = `/${locale}/${nodeCategory?.slug}`;

  let href = `/${locale}/${category?.slug || nodeCategory?.slug}/${slug}`;

  if (!category?.slug && !nodeCategory?.slug) {
    href =  `/${locale}/${slug}`
  }

  if (!categoryLabel){
    categoryLabel = shortHeading;
  }

  return {
    heading: seo?.title || shortHeading || heading,
    category: post ? {
      label: categoryLabel,
      href: categoryHref
    } : categoryLabel,
    date: post ? {
      label: blogpost_data?.[locale]?.updatedAtLabel ?? "",
      iso: dateFormat,
      string: createdAtShortDate
    } : {
      label: blogpost_data?.[locale]?.updatedAtLabel ?? "",
      iso: dateFormat,
      string: createdAtFullDate
    },
    dateFormat: dateFormat,
    href: href,
    description: shortContent,
    picture: {
      src: thumbnailImage?.url || null,
      alt: heading
    },
    readingTime: !post && content?.content && `${getReadingTime(content.content)} min`
  };
});
